"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings.numberings",
    path: "numberings",
    component: "Numberings"
});
let Numberings = class Numberings extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_numbering');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_8320016629450276_editable;
    b_8320016629450276_columns;
    dataMembers = ['items', 'ux', 'b_7315092382398562_modalBindings', 'b_8320016629450276_editable', 'b_8320016629450276_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_8320016629450276_editable: false,
                b_8320016629450276_columns: [{
                        name: "key",
                        header: this.$fn.pgettext("Numbering", "Key"),
                        type: "link",
                        width: "120px",
                    },
                    {
                        name: "resource_type",
                        header: this.$fn.pgettext("Numbering", "Resource Type"),
                        width: "120px",
                    },
                    {
                        name: "description",
                        header: this.$fn.pgettext("Numbering", "Description"),
                        width: "160px",
                    },
                    {
                        name: "format",
                        header: this.$fn.pgettext("Numbering", "Format"),
                        width: "260px",
                    },
                    {
                        name: "increment",
                        type: "number",
                        header: this.$fn.pgettext("Numbering", "Increment"),
                        width: "110px",
                    },
                    {
                        name: "next_value",
                        type: "number",
                        header: this.$fn.pgettext("Numbering", "Next value"),
                        width: "110px",
                    },
                    {
                        name: "next_number",
                        type: "number",
                        header: this.$fn.pgettext("Numbering", "Next Number"),
                        width: "110px",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_closeModal_3824_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_4615685607825208_showModal_3826_getActionArgs($event) {
        return {
            name: "Numbering",
        };
    }
    async evh_4615685607825208_click(event, scope) {
        return await this.actions.evh_4615685607825208_click.executeFromDOM(this, event, scope);
    }
    async evh_2095089031469157_click(event, scope) {
        return await this.actions.evh_2095089031469157_click.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_script_3830_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('numbering').upsert({
            ...$event.data.row,
            start: $event.data.row.lastvalue
        }));
    }
    async act_8320016629450276_script_3830_getActionArgs($event) {
        return {
            value: () => this.act_8320016629450276_script_3830_getActionArgs_value($event),
        };
    }
    async evh_8320016629450276_save(event, scope) {
        return await this.actions.evh_8320016629450276_save.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_script_3832_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('numbering').delete($event.data.row));
    }
    async act_8320016629450276_script_3832_getActionArgs($event) {
        return {
            value: () => this.act_8320016629450276_script_3832_getActionArgs_value($event),
        };
    }
    async evh_8320016629450276_delete(event, scope) {
        return await this.actions.evh_8320016629450276_delete.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_3834_getActionArgs($event) {
        return {
            name: "Numbering",
            props: {
                oid: $event.data.row.id,
            },
        };
    }
    async evh_8320016629450276_click_3833_getWhen($event) {
        return $event.data.col.name === 'key';
    }
    async evh_8320016629450276_click(event, scope) {
        return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3824 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3824_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3823 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3824,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3823],
        });
        const act_4615685607825208_showModal_3826 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4615685607825208_showModal_3826_getActionArgs,
            events: [],
        });
        const evh_4615685607825208_click_3825 = new core_1.actions.EventHandlerImpl({
            action: act_4615685607825208_showModal_3826,
            event: "click",
            displayName: "showModal",
        });
        const evh_4615685607825208_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4615685607825208_click_3825],
        });
        const act_2095089031469157_reloadComponentData_3828 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2095089031469157_click_3827 = new core_1.actions.EventHandlerImpl({
            action: act_2095089031469157_reloadComponentData_3828,
            event: "click",
            displayName: "reloadComponentData",
        });
        const evh_2095089031469157_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2095089031469157_click_3827],
        });
        const act_8320016629450276_script_3830 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8320016629450276_script_3830_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_save_3829 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_script_3830,
            event: "save",
            displayName: "script",
        });
        const evh_8320016629450276_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_save_3829],
        });
        const act_8320016629450276_script_3832 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8320016629450276_script_3832_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_delete_3831 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_script_3832,
            event: "delete",
            displayName: "script",
        });
        const evh_8320016629450276_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_delete_3831],
        });
        const act_8320016629450276_showModal_3834 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_3834_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_click_3833 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_3834,
            event: "click",
            when: this.evh_8320016629450276_click_3833_getWhen,
            displayName: "showModal",
        });
        const evh_8320016629450276_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_click_3833],
        });
        return {
            act_7315092382398562_closeModal_3824,
            evh_7315092382398562_close_3823,
            evh_7315092382398562_close,
            act_4615685607825208_showModal_3826,
            evh_4615685607825208_click_3825,
            evh_4615685607825208_click,
            act_2095089031469157_reloadComponentData_3828,
            evh_2095089031469157_click_3827,
            evh_2095089031469157_click,
            act_8320016629450276_script_3830,
            evh_8320016629450276_save_3829,
            evh_8320016629450276_save,
            act_8320016629450276_script_3832,
            evh_8320016629450276_delete_3831,
            evh_8320016629450276_delete,
            act_8320016629450276_showModal_3834,
            evh_8320016629450276_click_3833,
            evh_8320016629450276_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Numberings.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Numberings.prototype, "onSize", null);
Numberings = __decorate([
    (0, vue_property_decorator_1.Component)()
], Numberings);
exports.default = Numberings;
vue_property_decorator_1.Vue.component("Numberings", Numberings);
